import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dd0cb67c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=dd0cb67c&prod&rel=stylesheet%2Fscss&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=dd0cb67c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0cb67c",
  null
  
)

export default component.exports